var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88281 5.43894C1.88281 4.2347 2.83022 3.21672 4.04948 3.21672H13.0495C14.2687 3.21672 15.2161 4.2347 15.2161 5.43894V11.6612C15.2161 12.8654 14.2687 13.8834 13.0495 13.8834H4.04948C2.83022 13.8834 1.88281 12.8654 1.88281 11.6612V5.43894ZM4.12116 4.55005L8.51138 7.702C8.52527 7.71198 8.53824 7.71518 8.54948 7.71518C8.56072 7.71518 8.57369 7.71198 8.58758 7.702L12.9778 4.55005H4.12116ZM13.8828 5.53428C13.8612 5.55465 13.8381 5.57382 13.8133 5.5916L9.36519 8.7851C8.876 9.13632 8.22296 9.13632 7.73377 8.7851L3.28567 5.5916C3.26091 5.57382 3.23772 5.55465 3.21615 5.53428V11.6612C3.21615 12.1751 3.61189 12.5501 4.04948 12.5501H13.0495C13.4871 12.5501 13.8828 12.1751 13.8828 11.6612V5.53428Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic-email.03c3333a4aa1920a60d2f7919258e663.svg";
export { ForwardRef as ReactComponent };